import { FC } from 'react';

import { Dots, theme, Typography } from '@/shared/design-system';

import { LegendItem, LegendRow } from './styled';

export const VerdictLegend: FC = () => (
  <LegendRow>
    <LegendItem>
      <Dots color="green" size="xs" />
      <Typography variant="body3" color={theme.colors.text.secondary}>
        Field matches
      </Typography>
    </LegendItem>
    <LegendItem>
      <Dots color="orange" size="xs" />
      <Typography variant="body3" color={theme.colors.text.secondary}>
        Field contradicts
      </Typography>
    </LegendItem>
  </LegendRow>
);
